import { render, staticRenderFns } from "./FinancialApproval.vue?vue&type=template&id=1945361c&scoped=true"
import script from "./FinancialApproval.vue?vue&type=script&lang=js"
export * from "./FinancialApproval.vue?vue&type=script&lang=js"
import style0 from "./FinancialApproval.vue?vue&type=style&index=0&id=1945361c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1945361c",
  null
  
)

export default component.exports